import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import {FaSolidIcon} from "../FontAwesomeIcons";
import {formatCurrency} from "../../helpers/CurrencyHelpers";
import {TYPE_WALLET_WELFARE} from "../CheckoutDiscount/Wallets/WalletsConstants";

export default class WalletView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        this.cardStyle = {
            minHeight: "220px",
            padding: "20px",
            cursor: "default",
            transition: "transform .2s ease, box-shadow .2s ease",
            boxShadow: "0 18px 40px rgba(15, 23, 42, 0.24)",
            borderRadius: "18px",
        }

        this.backgroundImageStyle = {
            backgroundImage: `url(${this.props.wallet.image_url || ""})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }

        this.overlayDarken = {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(135deg, rgba(8,15,32,0.6) 0%, rgba(8,15,32,0.85) 100%)",
            zIndex: 0
        }

        this.overlayGlowStyle = {
            position: "absolute",
            top: "-80px",
            right: "-40px",
            width: "220px",
            height: "220px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.05)",
            zIndex: 0
        }

        this.overlayShineStyle = {
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            height: "96px",
            background: "linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 100%)",
            zIndex: 0
        }

        this.contentStyle = {
            position: "relative",
            zIndex: 1
        }

        this.titleStyle = {
            fontSize: "20px",
            lineHeight: "1.2"
        }

        this.supportingTextStyle = {
            opacity: 0.82
        }

        this.mainMetricBoxStyle = {
            borderRadius: "18px",
            backgroundColor: "rgba(255,255,255,0.12)",
            border: "1px solid rgba(255,255,255,0.12)",
            padding: "14px 16px",
        }

        this.metricValueStyle = {
            fontSize: "28px",
            fontWeight: "700",
            lineHeight: "1"
        }

        this.metricSuffixStyle = {
            fontSize: "16px",
            fontWeight: "500",
            opacity: 0.78
        }

        this.progressTrackStyle = {
            height: "8px",
            borderRadius: "999px",
            backgroundColor: "rgba(255,255,255,0.2)",
            overflow: "hidden"
        }

        this.progressBarStyle = {
            height: "100%",
            borderRadius: "999px",
            background: "linear-gradient(90deg, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.55) 100%)"
        }

        this.infoPillStyle = {
            borderRadius: "16px",
            padding: "12px 14px",
            backgroundColor: "rgba(255,255,255,0.12)",
            border: "1px solid rgba(255,255,255,0.12)",
            minHeight: "74px"
        }

        this.infoLabelStyle = {
            fontSize: "11px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            opacity: "0.72"
        }

        this.disabledBannerStyle = {
            borderTopLeftRadius: "18px",
            borderTopRightRadius: "18px"
        }
    }

    getWalletTitle = _ => {
        switch (this.props.wallet.type) {
            case TYPE_WALLET_WELFARE:
                return "IL TUO WELFARE"
            default:
                if (this.props.wallet.name) return this.props.wallet.name.toUpperCase()
                return this.props.wallet.type.replaceAll("_", " ").toUpperCase()
        }
    }

    getProgressPercentage = _ => {
        const totalAmount = parseFloat(this.props.wallet.inbound_balance || 0)
        const availableAmount = parseFloat(this.props.wallet.saldo_disponibile || 0)
        if (!totalAmount) return 0
        return Math.max(0, Math.min(100, (availableAmount / totalAmount) * 100))
    }

    getValidityText = _ => {
        const w = this.props.wallet
        if (w.data_inizio && w.data_fine) {
            return (
                <>Dal {moment(w.data_inizio).format("DD-MM-YYYY")} <br/> al {moment(w.data_fine).format("DD-MM-YYYY")}</>
            )
        }
        if (w.data_inizio) {
            return `Dal ${moment(w.data_inizio).format("DD-MM-YYYY")}`
        }
        if (w.data_fine) {
            return `Fino al ${moment(w.data_fine).format("DD-MM-YYYY")}`
        }
        return `Creato il ${moment(w.data_creazione).format("DD-MM-YYYY")}`
    }

    isClickable = _ => !!this.props.clickable && !!this.props.handleOnClick && !this.props.wallet.disabled

    handleClick = _ => {
        if (!this.isClickable()) return ""
        return this.props.handleOnClick(this.props.wallet)
    }

    handlePaymentInfoClick = e => {
        e.stopPropagation()
        if (!this.props.onPaymentInfoClick) return ""
        return this.props.onPaymentInfoClick(this.props.wallet)
    }

    render() {
        let w = this.props.wallet
        const availableAmount = parseFloat(w.saldo_disponibile || 0)
        const totalAmount = parseFloat(w.inbound_balance || 0)
        const progressPercentage = this.getProgressPercentage()

        return (
            <div>
                {
                    w.disabled ? <div className={"bg-warning text-white p-2"} style={this.disabledBannerStyle}>
                        <FaSolidIcon name={"exclamation-triangle"}/>
                        Questa gift card verrà abilitata appena l'attività approverà il tuo ordine #{w.id_operazione}
                    </div> : ""
                }

                <div
                    className={"card border-0 text-white overflow-hidden " + (w.image_url ? "" : "bg-" + w.color)}
                    style={{
                        ...this.cardStyle,
                        ...(w.image_url ? this.backgroundImageStyle : {}),
                    }}
                    onClick={this.handleClick}
                >
                    <div style={this.overlayDarken}></div>
                    <div style={this.overlayGlowStyle}></div>
                    <div style={this.overlayShineStyle}></div>

                    <div style={this.contentStyle}>
                        <div>
                            <div className={"font-weight-bold"} style={this.titleStyle}>
                                {this.getWalletTitle()}
                            </div>
                            <div className={"small mt-2"} style={this.supportingTextStyle}>
                                {w.price > 0 ?
                                    <span>
                                        Acquistato a {formatCurrency(w.price, "EUR", "it-IT")}
                                        {
                                            this.props.showPaymentInfoButton &&
                                            <span className={"ml-2"} onClick={this.handlePaymentInfoClick}>
                                                <FaSolidIcon name={"info-circle"}/>
                                            </span>
                                        }
                                    </span> :
                                    <span>Gift card disponibile nel tuo profilo</span>
                                }
                            </div>
                        </div>

                        <div className={"mt-4"} style={this.mainMetricBoxStyle}>
                            <div className={"d-flex justify-content-between align-items-end"}>
                                <div>
                                    <div style={this.infoLabelStyle}>Saldo disponibile</div>
                                    <div style={this.metricValueStyle}>
                                        {formatCurrency(availableAmount, "EUR", "it-IT")}
                                        <span className={"ml-1"} style={this.metricSuffixStyle}>
                                            / {formatCurrency(totalAmount, "EUR", "it-IT")}
                                        </span>
                                    </div>
                                </div>
                                <div className={"text-right small"} style={this.supportingTextStyle}>
                                    {progressPercentage.toFixed(0)}% residuo
                                </div>
                            </div>
                            <div className={"mt-3"} style={this.progressTrackStyle}>
                                <div style={{...this.progressBarStyle, width: `${progressPercentage}%`}}></div>
                            </div>
                        </div>

                        <div className={"row mt-3"}>
                            <div className={"col-7 pr-2"}>
                                <div style={this.infoPillStyle}>
                                    <div style={this.infoLabelStyle}>Validità</div>
                                    <div className={"font-weight-bold mt-1"}>{this.getValidityText()}</div>
                                </div>
                            </div>
                            <div className={"col-5 pl-2"}>
                                <div style={this.infoPillStyle}>
                                    <div style={this.infoLabelStyle}>Stato</div>
                                    <div className={"font-weight-bold mt-1"}>
                                        {w.disabled ? "In attesa" : (availableAmount > 0 ? "Attiva" : "Esaurita")}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            this.isClickable() &&
                            <div className={"small mt-3"} style={this.supportingTextStyle}>
                                Tocca per vedere dettaglio, spendibilità e movimenti della gift card
                            </div>
                        }
                    </div>
                </div>

            </div>
        )
    }
}

WalletView.propTypes = {
    wallet: PropTypes.object,
    handleOnClick: PropTypes.func,
    clickable: PropTypes.bool,
    showPaymentInfoButton: PropTypes.bool,
    onPaymentInfoClick: PropTypes.func
}
